import { render, staticRenderFns } from "./MainMenuAsideComponent.vue?vue&type=template&id=39102a5c&scoped=true"
import script from "./MainMenuAsideComponent.vue?vue&type=script&lang=js"
export * from "./MainMenuAsideComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39102a5c",
  null
  
)

export default component.exports